import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ENV_TOKEN } from '../../app-module.token';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  public constService: any;
  readonly environment = inject(ENV_TOKEN);
  private http: HttpClient = inject(HttpClient);

  constructor() {
    this.constService = this.environment;
  }



  // SERVICIO GET
  public getRequest = (url: string, customheaders?: object) => this.http.get(`${this.constService.apiBaseUrl}${url}`, customheaders);

  // SERVICIO POST
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public postRequest = (url: string, parametros?: object, customheaders?: object) => this.http.post(`${this.constService.apiBaseUrl}${url}`, parametros);

  // SERVICIO PUT
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public putRequest = (url: string, parametros?: object, customheaders?: object) => this.http.put(`${this.constService.apiBaseUrl}${url}`, parametros);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public putRequestBody = (url: string, parametros?: object, customheaders?: object) => this.http.request('put', `${this.constService.apiBaseUrl}${url}`, { body: parametros });

  // SERVICIO DELETE
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public deleteRequest = (url: string, parametros?: object, customheaders?: object) => this.http.delete(`${this.constService.apiBaseUrl}${url}`, parametros);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public deleteRequestBody = (url: string, parametros?: object, customheaders?: object) => this.http.request('delete', `${this.constService.apiBaseUrl}${url}`, { body: parametros });

  // SERVICIO POST CATALOGOS
  public postRequestCat = (url: string, parametros?: object, customheaders?: object) => this.http.post(`${url}`, parametros, customheaders);

  // GET FILE
  getFile = (urlFile: string) => this.http.get(`${urlFile}`);
}


